<template>
  <div class="news-all">
    <div class="title"><span class="time">12.13<br>2017</span><span class="tiel">美菜网荣登“2017年中国产业互联网TOP100排行榜”</span></div>
    <div class="mat-content">
        <div class="tet-js">
            12月13日，由工业和信息化部、中国科学技术协会联合指导，国家工业信息安全发展研究中心、工信部软件与集成电路促进中心、北京市海淀区人民政府、中国科协企业创新服务中心、中国产业互联网发展联盟联合主办的“2017中国产业互联与数字经济大会峰会”在北京召开。<br/><br/>
            大会围绕主题“整合、融通、再造”，旨在促进传统产业与互联网的无缝对接，聚合政府、企业、研究机构的各方共识和创造力，探寻中国产业互联网的发展之路，工业和信息化部党组成员、副部长罗文参加会议并致辞。<br/><br/>
        </div>
        <p align="center"><img src="@/assets/images/new-img/a10_01.jpg" width="640"></p>
        <div class="tet-js" style="text-align: center">
            工信部副部长罗文 致辞
        </div>
        <div class="tet-js">
            罗文表示，我国数字经济发展取得了突飞猛进的巨大成就。电子商务交易额位居世界首位，以互联网、大数据等为代表的数字经济已经深刻融入到我国经济社会各领域，正成为推动经济发展质量变革、效率变革、动力变革的重要驱动力。并指出，党中央、国务院高度重视实体经济和数字经济的融合发展。党的十九大报告指出，要推动互联网、大数据、人工智能和实体经济深度融合。<br/><br/>
            会上，中国产业互联网发展联盟发布了“2017年中国产业互联网TOP100榜单”，旨在激励各个传统产业与互联网相互融合，发挥各自最大优势，力争为中国产业互联网的发展树立风向标。中国产业互联网TOP100有四大“评选标准”：开放程度和普惠性；发展层级和领先性；市场规模和代表性；资本价值和成长性。“美菜网”荣登2017年中国产业互联网TOP100排行榜！<br/><br/>
            <p align="center"><img src="@/assets/images/new-img/a10_02.jpg" width="640"></p>
        </div>
        <div class="tet-js">
            美菜网于2014年成立，致力于用前卫的理念和先进的科技改变落后的中国农业市场。美菜网独有的商业模式通过自建仓储、物流、配送，创新升级农产品供应链，砍掉所有的中间环节，一端链接田间地头，一端链接市场和城市消费，实现农户和餐厅的直接交付。同时，美菜网利用大数据系统，准确将市场需求反馈给农民，一方面避免了货不对市，另一方面通过解决销路给予了农民安心的保障。此外，美菜网利用自身的渠道优势，要求源头端建立生产标准，保证上行农产品的质量安全，真正实现生产有标准、销路有保障的良性循环。<br/><br/>
            历经三年多的发展，美菜网全面布局，覆盖全国近50个城市，估值已超过30亿美金，已经成为国内知名的农产品移动电商平台。<br/><br/>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: "news-item"
};
</script>

<style lang="scss" scoped>
</style>
